module.exports = __webpack_public_path__ + "static/Customize-Welcome-Message-1-e1403554696728-ae533562822cc020a9cf2fca2502e948.jpg";